<template>
  <div v-show="show" class="m-share" @click="hide">
    <section class="m-share-box" @click.stop>
      <div class="m-share-box-top">
        <dl @click="share(3)">
          <dt><img :src="icons.wx"></dt>
          <dd class="fz14">微信</dd>
        </dl>
        <dl @click="share(4)">
          <dt><img :src="icons.moment"></dt>
          <dd class="fz14">朋友圈</dd>
        </dl>
      </div>
      <div class="m-share-cancel fz15" @click="hide">
        取消
      </div>
    </section>
  </div>
</template>

<script>
import iconWx from '@/assets/icons/icon-weixin.png'
import iconMoment from '@/assets/icons/icon-weixinfriend.png'
export default {
  computed: {
    show () {
      return this.$store.state.share.show
    }
  },
  methods: {
    hide () {
      this.$store.dispatch('hideShare')
    },
    share (type) {
      this.$store.dispatch('appSharePage', type)
    }
  },
  data () {
    return {
      icons: {
        wx: iconWx,
        moment: iconMoment
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// share.vue?0ae92020